module.exports = {"imageUrl":"Templates/imagesCards_v1_PaySSL/images/","templateName":"Cards_v1_PaySSL","variationName":"ssl"}


//////////////////
// WEBPACK FOOTER
// ./src/data/config.json
// module id = 396
// module chunks = 0